import {
  Button,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from '@ibsys/kit';
import { HistoryIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTriggerTooltip } from '@/shared/lib';
import { EvaluationCommentText } from './EvaluationCommentText';

type Props = {
  /** Комментарий, составленный системой, — его и показываем */
  comment: string;
  expertReportId: number;
  blockId: number;
};

/**
 * Просмотр первичного комментария правила, составленного системой.
 * Рендерится у правила с изменённым комментарием — пока комментарий не менялся, показывать нечего.
 * Автор и время правки здесь не показываются — они видны в разделе «Обратная связь».
 */
export const EvaluationRuleCommentHistory: FC<Props> = ({ comment, expertReportId, blockId }) => {
  const { t } = useTranslation(['dialogs']);
  const title = t('dialogs:expertReport.originalComment');
  const tooltip = useTriggerTooltip();

  return (
    <DialogRoot onOpenChange={tooltip.handleWindowOpenChange}>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-5 align-middle"
          aria-label={title}
          tooltip={title}
          onFocus={tooltip.handleFocus}
          onPointerMove={tooltip.handlePointerMove}
          icon={<HistoryIcon className="size-3" />}
        />
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="text-sm">
          <EvaluationCommentText comment={comment} expertReportId={expertReportId} blockId={blockId} />
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t('dialogs:expertReport.close')}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
